
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PricingNavigation = () => {
  return (
    <nav className="container mx-auto px-6 py-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold text-gray-900">ScoutLink.ai</Link>
        <div className="space-x-4">
          <Link to="/request-access">
            <Button variant="ghost" className="bg-blue-100 text-blue-700">Request Access</Button>
          </Link>
          <Link to="/analytics">
            <Button variant="ghost">Sign In</Button>
          </Link>
          <Link to="/request-access">
            <Button>Get Started</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default PricingNavigation;
